import { postForm } from './BaseRequests'

export const postPetContestSubmission = ({ details, image }, success, fail) => {
    postForm("petContestSubmission", { details, image })
      .then(response => {
        if (response.success) {
          success(true)
        } else {
          if (response.message) {
              fail(response.message)
          }
          fail("Error with contest submission request")
        }
      }).catch(fail)
}